import { EditOutlined, PlusOutlined } from '@ant-design/icons';
import { Button, Empty, Input, List, Modal, Spin, message } from 'antd';
import { useState } from 'react';
import { AiConversation } from '../../api/aiAssistant';

interface Props {
  conversations: AiConversation[];
  loading: boolean;
  activeId: string | null;
  onSelect: (id: string) => void;
  onNew: () => void;
  onRename: (id: string, title: string) => Promise<void>;
}

const ConversationList = (props: Props) => {
  const { conversations, loading, activeId, onSelect, onNew, onRename } = props;
  const [renameTarget, setRenameTarget] = useState<AiConversation | null>(null);
  const [renameValue, setRenameValue] = useState('');
  const [renaming, setRenaming] = useState(false);

  const handleRename = async () => {
    if (!renameTarget) return;
    const title = renameValue.trim();
    if (!title) {
      message.warning('标题不能为空');
      return;
    }
    setRenaming(true);
    try {
      await onRename(renameTarget.id, title);
      setRenameTarget(null);
    } finally {
      setRenaming(false);
    }
  };

  return (
    <div
      style={{
        width: 260,
        flexShrink: 0,
        display: 'flex',
        flexDirection: 'column',
        borderRight: '1px solid #f0f0f0',
        paddingRight: 16,
      }}
    >
      <Button type="primary" icon={<PlusOutlined />} onClick={onNew} block>
        新建对话
      </Button>
      <Spin spinning={loading}>
        <List
          style={{ marginTop: 12, overflowY: 'auto' }}
          dataSource={conversations}
          locale={{
            emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="暂无历史对话" />,
          }}
          renderItem={(item) => (
            <List.Item
              onClick={() => onSelect(item.id)}
              style={{
                cursor: 'pointer',
                padding: '8px 12px',
                borderRadius: 6,
                background: activeId === item.id ? '#e6f4ff' : undefined,
              }}
              actions={[
                <Button
                  key="rename"
                  type="text"
                  size="small"
                  aria-label="重命名"
                  icon={<EditOutlined />}
                  onClick={(e) => {
                    e.stopPropagation();
                    setRenameTarget(item);
                    setRenameValue(item.title);
                  }}
                />,
              ]}
            >
              <List.Item.Meta
                title={
                  <span
                    style={{
                      display: 'block',
                      maxWidth: 130,
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                      fontWeight: activeId === item.id ? 600 : 400,
                    }}
                    title={item.title}
                  >
                    {item.title}
                  </span>
                }
              />
            </List.Item>
          )}
        />
      </Spin>

      <Modal
        title="重命名对话"
        open={!!renameTarget}
        onOk={handleRename}
        confirmLoading={renaming}
        onCancel={() => setRenameTarget(null)}
        destroyOnClose
      >
        <Input
          value={renameValue}
          maxLength={100}
          placeholder="请输入对话标题"
          onChange={(e) => setRenameValue(e.target.value)}
          onPressEnter={handleRename}
        />
      </Modal>
    </div>
  );
};

export default ConversationList;
